import GroupForecasterManager from './GroupForecasterManager.vue';

export const groupForecastRoutes = [
  {
    path: 'group-forecaster-pro/:periodGuid',
    component: GroupForecasterManager,
    name: 'group-forecaster-pro'
  }
];
